import { render, staticRenderFns } from "./coupon.vue?vue&type=template&id=b0b9c7b6&scoped=true&"
import script from "./coupon.vue?vue&type=script&lang=js&"
export * from "./coupon.vue?vue&type=script&lang=js&"
import style0 from "./coupon.vue?vue&type=style&index=0&id=b0b9c7b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b9c7b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0b9c7b6')) {
      api.createRecord('b0b9c7b6', component.options)
    } else {
      api.reload('b0b9c7b6', component.options)
    }
    module.hot.accept("./coupon.vue?vue&type=template&id=b0b9c7b6&scoped=true&", function () {
      api.rerender('b0b9c7b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customChildren/coupon.vue"
export default component.exports